<div class="flex flex-col items-center justify-center h-full text-neutral-300">
  <i class="ph ph-barricade text-[350px]"></i>

  <div
    class="empty-state text-center font-bold text-base"
    data-testId="authorization-error-component"
  >
    It looks like you don't have access to this information. <br />
    Check with your admin for more details.
  </div>
</div>
